import React, { Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { skipToken } from '@reduxjs/toolkit/query';
import { PageLoader } from '@/widgets/PageLoader';
import { routeConfig } from '../lib/routeConfig';
import { noAuthConfig } from '@/app/providers/router/lib/noAuthConfig';
import { useAppSelector } from '@/shared/lib/hooks/redux';
import { Alert } from '@/entities/Alert';
import { useGetUserListDataQuery } from '@/entities/User';
import { useGetClubsQuery } from '@/entities/Club';

const router = createBrowserRouter(routeConfig);
const noAuthRouter = createBrowserRouter(noAuthConfig);

export const AppRouter = () => {
  const { isAuth, isAuthLoading } = useAppSelector((state) => state.app);
  const isClubRoute = window.location.pathname === '/club';
  const usersQuery = useGetUserListDataQuery(isClubRoute ? skipToken : undefined);
  const clubsQuery = useGetClubsQuery(isClubRoute ? undefined : skipToken);
  const isLoading = isAuthLoading || usersQuery.isLoading || clubsQuery.isLoading;
  const { isOpen } = useAppSelector((state) => state.alert);

  return (
    <>
      <Suspense fallback={<PageLoader />}>
        {isLoading ? <PageLoader /> : <RouterProvider router={isAuth ? router : noAuthRouter} />}
      </Suspense>

      {isOpen && <Alert />}
    </>
  );
};
